import { render, staticRenderFns } from "./BeiJingReadCard.vue?vue&type=template&id=535b47b4&scoped=true&"
import script from "./BeiJingReadCard.vue?vue&type=script&lang=js&"
export * from "./BeiJingReadCard.vue?vue&type=script&lang=js&"
import style0 from "./BeiJingReadCard.vue?vue&type=style&index=0&id=535b47b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b47b4",
  null
  
)

export default component.exports